export default __webpack_public_path__ + "static/media/phone_icon.b4490be8.png";